import PropTypes from 'prop-types';
import React from 'react';

import {
  LightSpan,
  PaymentContainer,
  Span,
  Stripe,
  StripeContainer,
  Text,
  Title,
  usePaymentInfoStyles,
} from './style';


const getStripeToken = (invoice) => {
  if (invoice.paymentConfirmation && invoice.paymentConfirmation.stripe) {
    const { paymentIntentId, tokenPayment } = invoice.paymentConfirmation.stripe;
    return tokenPayment || paymentIntentId || '';
  }
  return '';
};

const stripeLink = token => (
  <StripeContainer>
    <Stripe
      href={`https://dashboard.stripe.com/payments/${token}`}
      target="_blank"
    >
      Stripe
    </Stripe>
  </StripeContainer>
);

const noPaymentLink = amount => (
  amount === 0
    ? <Span>Free service</Span>
    : <Span>Payment link not found</Span>
);

const PaymentInfo = ({
  invoices, promoCode, seller,
}) => {
  const classes = usePaymentInfoStyles();
  const lastInvoice = (invoices.length && invoices[invoices.length - 1]) || {};
  const amount = lastInvoice.amount || 0;
  const stripeToken = getStripeToken(lastInvoice);
  return (
    <div className={classes.root}>
      <Title>Payment</Title>
      <PaymentContainer>
        <Text>
          <Span>Total</Span>
          {`${amount}€`}
        </Text>
        {stripeToken
          ? stripeLink(stripeToken)
          : noPaymentLink(amount)}
        <Text>
          <Span>Promocode</Span>
          {promoCode
            ? `${promoCode}`
            : (<LightSpan>None</LightSpan>)}
        </Text>
        <Text>
          <Span>Affiliate</Span>
          {seller
            ? `${seller}`
            : (<LightSpan>---</LightSpan>)}
        </Text>
      </PaymentContainer>

    </div>
  );
};

PaymentInfo.propTypes = {
  invoices: PropTypes.arrayOf(
    PropTypes.shape({
      amount: PropTypes.number,
    })
  ),
  promoCode: PropTypes.string,
  seller   : PropTypes.string,
};

PaymentInfo.defaultProps = {
  invoices : [],
  promoCode: '',
  seller   : '',
};

export default PaymentInfo;
